import styled from "styled-components";

export const ProfileImageUploadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  label {
    color: var(--Neutral-60, #fff);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: -0.18px;
  }

  .error-message {
    color: var(--chart-color-01);
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    margin-top: 4px;
  }
`;

export const ProfileImageUploadBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px;
  border-radius: 12px;
  border: 1.5px dashed
    ${(props) =>
      props.isDragging ? "var(--primary-100)" : "var(--Neutral-40)"};

  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: var(--primary-100);
    background: var(--primary-8);
  }

  .upload-icon {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 24px;
      height: 24px;
    }
  }

  .upload-text {
    color: var(--Neutral-100);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.14px;

    .browse-text {
      font-weight: 500;
      text-decoration: underline;
    }

    .or-text {
      font-weight: 400;
    }
  }

  .file-info {
    color: var(--Neutral-60);
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.12px;
  }

  &.file-preview {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border: 1px solid var(--Neutral-80);
    border-style: solid;
    background: var(--Success-8);
    cursor: default;
    padding: 10px;
    min-height: auto;

    &:hover {
      border-color: var(--Neutral-40);
      background: var(--Success-8);
    }

    .file-details {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;

      .file-icon {
        min-width: 40px;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        background: var(--Neutral-20);
        overflow: hidden;

        img {
          width: 40px;
          height: 40px;
          object-fit: cover;
          border-radius: 4px;
        }
      }

      .file-info-text {
        display: flex;
        flex-direction: column;
        gap: 4px;

        .file-name {
          color: var(--Neutral-100);
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          letter-spacing: -0.14px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .file-status {
          display: flex;
          align-items: center;
          gap: 4px;
          color: var(--Success-100);
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: -0.12px;

          svg {
            width: 16px;
            height: 16px;
          }
        }

        .file-status.loading {
          color: var(--primary-100);
        }
      }
    }

    .delete-btn {
      background: none;
      border: none;
      cursor: pointer;
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      transition: background 0.2s ease;

      &:hover {
        background: var(--Error-8);
      }

      &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }

      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
`;
